import { useEffect } from 'react'
import * as PropTypes from 'prop-types'
import { endOfToday } from 'date-fns'
import moment from 'moment-timezone'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { selectActiveBuilding } from '../../../reducers/buildingSelectorReducer'
import DateField from '../../FormLegacy/FormFieldsV2/DateField'
import Icon from '../../Icons'

import { getScheduleMinTime } from './helpers'

const ScheduleSetupModal = ({
  handleCancel,
  handleSubmit,
  values,
  handleChange,
  templateType,
  isSubmitting,
  isDisabled,
}) => {
  const { t } = useTranslation(['organisation', 'common'])
  const selectedBuilding = useSelector(selectActiveBuilding)
  const cancelAndClearDate = () => {
    handleCancel()
    handleChange({ target: { name: 'deliveryDate', value: undefined } })
    handleChange({ target: { name: 'deliveryTime', value: undefined } })
  }

  useEffect(() => {
    handleChange({ target: { name: 'deliveryTime', value: null } })
  }, [values.deliveryDate])

  return (
    <div className="schedule-setup">
      <div className="schedule-setup__container">
        <div className="window-header">
          <div className="title-with-icon">
            <div className="navi-button">
              <Icon
                fill="none"
                viewBox="0 0 24 24"
                svgProps={{
                  stroke: '#3C3C3C',
                  strokeWidth: '1.5',
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                }}
                icon="scheduledMessage"
              />
            </div>
            <div className="title">
              {t('organisation:communicationPortal.scheduleSetupModal.title')}
            </div>
          </div>
          <div className="navi-button" onClick={cancelAndClearDate}>
            <Icon icon="cross" />
          </div>
        </div>
        <div className="main-view">
          <DateField
            name="deliveryDate"
            onChange={handleChange}
            label={t('organisation:communicationPortal.scheduleSetupModal.deliveryDateLabel')}
            minDate={moment().toDate()}
            value={values.deliveryDate}
            placeholderText={t(
              'organisation:communicationPortal.emailTemplate.selectDeliveryDatePlaceholder',
            )}
            additionalClass="reservation-picker"
            autoComplete="off"
          />
          <DateField
            disabled={!values.deliveryDate}
            name="deliveryTime"
            label={t('organisation:communicationPortal.scheduleSetupModal.deliveryTimeLabel')}
            placeholderText={t(
              'organisation:communicationPortal.emailTemplate.selectDeliveryTimePlaceholder',
            )}
            value={values.deliveryTime}
            onChange={handleChange}
            popperClassName="schedule-setup__container__wide-date-field"
            minTime={getScheduleMinTime(values.deliveryDate, selectedBuilding.timezone)}
            maxTime={endOfToday()}
            showTimeSelect
            showTimeSelectOnly
            timeIntervals={30}
            timeCaption="Start Time"
            dateFormat="hh:mm a"
            autoComplete="off"
          />
        </div>
        <div className="window-footer">
          <div className="footer-buttons">
            <button className={'button button-gray is-block'} onClick={cancelAndClearDate}>
              {t('common:actions.cancel')}
            </button>
            <button
              type="submit"
              onClick={handleSubmit}
              disabled={isSubmitting || isDisabled || !values.deliveryTime || !values.deliveryDate}
              className={'button button-primary is-block'}
            >
              {templateType === 'email'
                ? t('organisation:communicationPortal.scheduleSetupModal.scheduleEmail')
                : t('organisation:communicationPortal.scheduleSetupModal.schedulePushNotification')}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

ScheduleSetupModal.propTypes = {
  handleCancel: PropTypes.func,
  handleSubmit: PropTypes.func,
  templateType: PropTypes.string,
  values: PropTypes.object,
  isDisabled: PropTypes.bool,
  handleChange: PropTypes.func,
  isSubmitting: PropTypes.bool,
  setSubmitting: PropTypes.func,
}

export default ScheduleSetupModal
